import { HelpersService } from 'src/app/services/helpers/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth/auth.service';
import { EventsService } from 'src/app/services/events/events.service';

export const ROUTER_GUARD_KEY = 'routerVisited';

@Injectable({
  providedIn: 'root'
})
export class RouterGuard  {

  constructor(private alertController: AlertController, private authService: AuthService,
    private translate: TranslateService, private helpers: HelpersService, private eventService: EventsService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    const isComplete = localStorage.getItem(ROUTER_GUARD_KEY);
    let user = this.authService.getUser();

    if (user && !(isComplete && (isComplete === 'true'))) {
      localStorage.setItem(ROUTER_GUARD_KEY, "true");
      this.welcomeRouter();
    }
    return true;
  }

  public welcomeRouter() {
    let title = this.translate.instant("router.alerts.welcomeAlert.title");
    let content = this.translate.instant("router.alerts.welcomeAlert.content");
    this.eventService.publish("disableBackButtonRouter", "router guard");
    this.alertController
      .create({
        message: `<div><img class="" src="assets/img/routerAlert.svg" alt=""></img></div><div><p class="font-bold rose-icon font-size-20">${title}</p></div><div><p>${content}</p></div>`,
        backdropDismiss: false,
        cssClass: "welcomeRouter",
        animated: true,
        buttons: [{
          text: this.translate.instant("router.alerts.welcomeAlert.button"),
          cssClass: "alert-button-custom flex-center",
          role: "cancel",
          handler: () => {
            console.log("Boton back");
            this.eventService.publish("enableBackButtonRouter", "router guard");
            this.helpers.goTo('router-tour');
          },
        },],
      })
      .then((res) => {
        res.present();
      });
  }

}